import React, { useContext,useState, useEffect } from 'react'
import bgimage from '../images/bgimage.jpg';
import Openchat from './Openchat';
import Sidebar from './Sidebar';
import '../styling/Chats.css'
import notecontext from '../context/notes/notecontext'
import { app, database, storage } from './firebaseConfig'
import { collection, addDoc,getDoc, getDocs, doc, updateDoc, deleteDoc ,onSnapshot,query,where,setDoc} from "firebase/firestore";
import { async } from '@firebase/util';

const Chats = () => {
  const collectionRef = collection(database, 'users')
    const context = useContext(notecontext);
    const { user, getUserdetails } = context;
    const [imagesrc, setimagesrc] = useState("https://www.pngall.com/wp-content/uploads/5/User-Profile-PNG-Image.png")


  useEffect(() => {
    getUserdetails();
    getImage();
}, [])

const getImage=async()=>{
  const emailQuery=query(collectionRef,where("email","==",user.email))
  // const imguser=[];
  // onSnapshot(emailQuery,(data)=>{
  //     console.log(data.docs.map((item) => {
  //            return { ...item.data()};
  //     }));
  //   })
  const querySnapshot = await getDocs(emailQuery);
  querySnapshot.forEach(async(doc) => {
      await setimagesrc(doc.data().imageURL)
    });
}

  return (
    <div style={{ backgroundImage: `url(${bgimage})`, "height": "100vh", "width": "100vw", "position": "absolute", backgroundSize: "cover" ,display:"flex", alignItems:"center",justifyContent:"center"}}>
        <div  id='chatcont' >
          <Sidebar user={user} imagesrc={imagesrc}/>
          <Openchat user={user}/>
        </div>
    </div>
  )
}

export default Chats